import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const apiBaseUrl = { baseURL: environment.get().api.serviceUrl };
const forceSamlSsoEndpoint = appconfig.endpoints.forceSamlSso;

export const daoForceSamlSsoGet = (email) => api.get(`${forceSamlSsoEndpoint}?email=${encodeURIComponent(email)}`, apiBaseUrl);
